import React, { useState } from 'react';
import moment from 'moment';
import { getRuta, simpleMessage } from '../../../../helpers/Helpers';
import {
	BotonGenerar,
	FormularioSelector,
	RangoFechas,
	SelectorGestor,
	SelectorOpciones,
	validarRangoFechas
} from '../../../../components/reportes/selector';

// Mismos valores que RecuperacionVencidos.Estado* en el servidor.
export const ESTADOS_ABONO = [
	{ valor: 1, nombre: 'ABONADOS' },
	{ valor: 2, nombre: 'NO ABONADOS' },
	{ valor: 0, nombre: 'TODOS' }
];

const SelectorRecuperacionVencidos = () => {
	const [selectedGestor, setSelectedGestor] = useState('t');
	// El reporte va siempre por nombre: la ruta conserva el parámetro de orden.
	const selectedSortBy = 0;
	const [estado, setEstado] = useState(0);
	const hoy = new Date();
	const [fechaDesde, setFechaDesde] = useState(new Date(hoy.getFullYear(), hoy.getMonth(), 1));
	const [fechaHasta, setFechaHasta] = useState(hoy);

	let ruta = getRuta();

	const verReport = () => {
		const errorFechas = validarRangoFechas(fechaDesde, fechaHasta);
		if (errorFechas) {
			simpleMessage(errorFechas, 'error');
			return;
		}

		var params = `${selectedGestor}/${selectedSortBy}/${moment(fechaDesde).format(
			'YYYY-MM-DD'
		)}/${moment(fechaHasta).format('YYYY-MM-DD')}/${estado}`;
		window.open(`${ruta}/r-recuperacionvencidos/${params}`);
	};

	return (
		<FormularioSelector>
			<SelectorGestor value={selectedGestor} onChange={setSelectedGestor} />

			<SelectorOpciones
				label="Créditos"
				value={estado}
				onChange={setEstado}
				opciones={ESTADOS_ABONO}
			/>

			<RangoFechas
				desde={fechaDesde}
				hasta={fechaHasta}
				onChangeDesde={setFechaDesde}
				onChangeHasta={setFechaHasta}
			/>

			<BotonGenerar onClick={verReport} />
		</FormularioSelector>
	);
};

export default SelectorRecuperacionVencidos;
